import { render } from "./SettlementOrderInfo.vue?vue&type=template&id=1ffb6894"
import script from "./SettlementOrderInfo.vue?vue&type=script&lang=js"
export * from "./SettlementOrderInfo.vue?vue&type=script&lang=js"

import "./SettlementOrderInfo.vue?vue&type=style&index=0&id=1ffb6894&lang=scss"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__